import { render, staticRenderFns } from "./viewWorksList.vue?vue&type=template&id=d75668ca"
import script from "./viewWorksList.vue?vue&type=script&lang=js"
export * from "./viewWorksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d75668ca')) {
      api.createRecord('d75668ca', component.options)
    } else {
      api.reload('d75668ca', component.options)
    }
    module.hot.accept("./viewWorksList.vue?vue&type=template&id=d75668ca", function () {
      api.rerender('d75668ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/technocracy/viewWorksList.vue"
export default component.exports